/* ============================================================
   Product Extras - Mark Ryden Wholesale
   Positions the volume pricing table and the Customize & Quote
   button on product pages, and holds the stock MOQ in the
   quantity input.
   ============================================================ */

(function () {
  'use strict';

  // Only run on product pages
  if (!document.body.classList.contains('template-product')) return;

  /* Stock minimum order quantity. Custom and OEM runs start at 100
     and go through the quote form, not the cart. */
  var MOQ = 50;
  var QTY_SEL = '.quantity__input, input[name="quantity"]';

  // ---- Hold the MOQ in the quantity input ----
  function applyMoq() {
    var q = document.querySelector(QTY_SEL);
    if (!q) return false;
    q.setAttribute('min', MOQ);
    if (!q.getAttribute('step')) q.setAttribute('step', '1');
    if (!q.value || parseInt(q.value, 10) < MOQ) {
      q.value = MOQ;
      q.dispatchEvent(new Event('change', { bubbles: true }));
      q.dispatchEvent(new Event('input', { bubbles: true }));
    }
    return true;
  }

  /* The theme rebuilds the quantity widget after load, so retry
     briefly rather than assuming it is there on first pass. */
  function holdMoq() {
    var tries = 0;
    (function attempt() {
      if (applyMoq() || tries++ > 20) return;
      setTimeout(attempt, 200);
    })();
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches(QTY_SEL)) return;
    if (parseInt(e.target.value, 10) < MOQ) e.target.value = MOQ;
  });

  // ---- Position Volume Pricing Table ----
  function placeVolumeTable() {
    var src = document.getElementById('bls-vol-table-src');
    if (!src) return;

    /* Alukas (BLS) selectors first, then Dawn and generic fallbacks.
       Without the bls__ ones the table never found an anchor and fell
       through to the bottom of the page. */
    var priceTarget = (
      document.querySelector('.product-detail__price') ||
      document.querySelector('.bls__product-price.biger-price') ||
      document.querySelector('.bls__product-price') ||
      document.querySelector('.product__price') ||
      document.querySelector('[class*="product__price"]') ||
      document.querySelector('.price--large') ||
      document.querySelector('.price__container') ||
      document.querySelector('.product-info .price') ||
      document.querySelector('[data-product-price]')
    );

    if (priceTarget) {
      var wrapper = priceTarget.closest('.product-detail__price, .product__price, .price__container, .product__price-wrapper') || priceTarget;
      wrapper.insertAdjacentElement('afterend', src);
    }
    src.style.display = '';
  }

  // ---- Add Customize & Quote Button ----
  function placeCustomizeButton() {
    if (document.querySelector('.bls-cq-trigger-btn')) return;

    var formEl = (
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product-form__buttons')
    );

    if (!formEl) return;

    var productTitle = (
      (document.querySelector('.product__title, .product-detail__name, h1.product__name') || {}).textContent ||
      document.title
    ).trim();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-open', 'customize-quote');
    btn.setAttribute('data-product', productTitle);
    btn.className = 'bls-btn bls-cq-trigger-btn';
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0">' +
        '<path d="M12 20h9"/>' +
        '<path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>' +
      '</svg>' +
      'CUSTOMIZE &amp; REQUEST QUOTE';

    btn.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'gap:8px',
      'width:100%',
      'margin-top:10px',
      'padding:14px 20px',
      'font-size:15px',
      'font-weight:800',
      'letter-spacing:0.5px',
      'border:2px solid #1a1a1a',
      'border-radius:6px',
      'background:transparent',
      'color:#1a1a1a',
      'cursor:pointer',
      'transition:all 0.2s',
      'white-space:nowrap',
      'text-transform:uppercase'
    ].join(';');

    btn.addEventListener('mouseenter', function () {
      btn.style.background = '#1a1a1a';
      btn.style.color = '#fff';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.background = 'transparent';
      btn.style.color = '#1a1a1a';
    });

    formEl.insertAdjacentElement('afterend', btn);
  }

  // ---- Run ----
  function init() {
    placeVolumeTable();
    placeCustomizeButton();
    holdMoq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
